import { freeze } from 'utils/object';

export type WALLET_TYPE =
  | 'metamask'
  | 'coinbaseWallet'
  | 'network'
  | 'walletconnect'
  | 'cardano'
  | 'trustwallet';

export const WALLET_TYPES = freeze({
  METAMASK: 'metamask',
  COINBASE_WALLET: 'coinbaseWallet',
  NETWORK: 'network',
  WALLET_CONNECT: 'walletconnect',
  WALLET_LINK: 'coinbaseWallet',
  CARDANO: 'cardano',
  TRUST_WALLET: 'trustwallet',
  SAFE_WALLET: 'safe',
  WEB_3_AUTH: 'Web3Auth',
  RABBY_WALLET: 'Rabby',
});

export const WALLET_NAMES = {
  METAMASK: 'Metamask',
  TRUST: 'Trust Wallet',
  WALLETCONNECT: 'WalletConnect',
  COINBASE: 'Coinbase Wallet',
  SAFE: 'Safe',
  WEB_3_AUTH: 'Web3Auth',
  RABBY_WALLET: 'Rabby',
  // NAMI: 'Nami',
  // ETERNL: 'Eternl',
};

export const SUPPORTED_CONNECTORS = freeze([
  WALLET_TYPES.METAMASK,
  // WALLET_TYPES.NETWORK,
  WALLET_TYPES.WALLET_CONNECT,
  // WALLET_TYPES.WALLET_LINK,
  // WALLET_TYPES.CARDANO,
  WALLET_TYPES.COINBASE_WALLET,
  WALLET_TYPES.TRUST_WALLET,
  WALLET_TYPES.SAFE_WALLET,
  WALLET_TYPES.WEB_3_AUTH,
  WALLET_TYPES.RABBY_WALLET,
]);
